import { render, staticRenderFns } from "./ProductTagCategoryNew.vue?vue&type=template&id=1464ab20&"
import script from "./ProductTagCategoryNew.vue?vue&type=script&lang=js&"
export * from "./ProductTagCategoryNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports